(() => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuPanel = document.querySelector('[data-menu-panel]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchClose = document.querySelector('[data-search-close]');
  const inquiryField = document.querySelector('[data-inquiry-field]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setPanel = (panel, trigger, open) => {
    if (!panel || !trigger) return;
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', String(!open));
    panel.inert = !open;
    trigger.setAttribute('aria-expanded', String(open));
  };

  menuToggle?.addEventListener('click', () => {
    const open = !menuPanel?.classList.contains('is-open');
    setPanel(menuPanel, menuToggle, open);
    setPanel(searchPanel, searchToggle, false);
    if (open) menuPanel?.querySelector('a')?.focus();
  });

  searchToggle?.addEventListener('click', () => {
    const open = !searchPanel?.classList.contains('is-open');
    setPanel(searchPanel, searchToggle, open);
    setPanel(menuPanel, menuToggle, false);
    if (open) searchPanel?.querySelector('input[type="search"]')?.focus();
  });

  searchClose?.addEventListener('click', () => {
    setPanel(searchPanel, searchToggle, false);
    searchToggle?.focus();
  });

  menuPanel?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setPanel(menuPanel, menuToggle, false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (menuPanel?.classList.contains('is-open')) {
      setPanel(menuPanel, menuToggle, false);
      menuToggle?.focus();
    }
    if (searchPanel?.classList.contains('is-open')) {
      setPanel(searchPanel, searchToggle, false);
      searchToggle?.focus();
    }
  });

  document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
    const slidesContainer = carousel.querySelector('.hero__slides');
    const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
    const dots = [...carousel.querySelectorAll('[data-hero-dot]')];
    const previous = carousel.querySelector('[data-hero-prev]');
    const next = carousel.querySelector('[data-hero-next]');
    const mediaToggle = carousel.querySelector('[data-media-toggle]');
    if (slides.length < 2) return;

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let paused = reduceMotion.matches || carousel.dataset.designMode === 'true';
    let mediaToggleFocusPaused = false;
    let inView = true;
    let timer;

    const activeVideo = () => slides[activeIndex].querySelector('video');
    const clearTimer = () => {
      window.clearInterval(timer);
      timer = undefined;
    };
    const startTimer = () => {
      clearTimer();
      if (!paused && inView && !document.hidden) timer = window.setInterval(() => show(activeIndex + 1), 5000);
    };
    const syncMotion = () => {
      slidesContainer?.setAttribute('aria-live', paused ? 'polite' : 'off');
      slides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.classList.toggle('is-moving', active && !paused && !reduceMotion.matches && !slide.querySelector('video'));
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        const video = slide.querySelector('video');
        if (!active || paused || !inView || document.hidden) video?.pause();
        if (active && !paused && inView && !document.hidden && video) video.play().catch(() => {});
      });
      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', String(active));
      });
    };
    const show = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      syncMotion();
    };
    const setPaused = (value) => {
      paused = value;
      mediaToggle?.classList.toggle('is-paused', paused);
      mediaToggle?.setAttribute('aria-pressed', String(paused));
      mediaToggle?.setAttribute('aria-label', paused ? mediaToggle.dataset.playLabel : mediaToggle.dataset.pauseLabel);
      if (paused) clearTimer();
      else startTimer();
      syncMotion();
    };

    previous?.addEventListener('click', () => show(activeIndex - 1));
    next?.addEventListener('click', () => show(activeIndex + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.heroDot))));
    mediaToggle?.addEventListener('click', (event) => {
      const keepPaused = mediaToggleFocusPaused && event.detail > 0;
      mediaToggleFocusPaused = false;
      setPaused(keepPaused || !paused);
    });
    carousel.addEventListener('focusin', (event) => {
      mediaToggleFocusPaused = event.target === mediaToggle && !paused;
      setPaused(true);
    });
    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(activeIndex - 1);
      if (event.key === 'ArrowRight') show(activeIndex + 1);
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearTimer();
        activeVideo()?.pause();
      } else if (!paused && inView) {
        startTimer();
        activeVideo()?.play().catch(() => {});
      }
    });
    reduceMotion.addEventListener?.('change', (event) => {
      if (event.matches) setPaused(true);
      else syncMotion();
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        if (!inView) {
          clearTimer();
          activeVideo()?.pause();
        } else if (!paused && !document.hidden) {
          startTimer();
          activeVideo()?.play().catch(() => {});
        }
      });
      observer.observe(carousel);
    }

    syncMotion();
    mediaToggle?.classList.toggle('is-paused', paused);
    mediaToggle?.setAttribute('aria-pressed', String(paused));
    mediaToggle?.setAttribute('aria-label', paused ? mediaToggle.dataset.playLabel : mediaToggle.dataset.pauseLabel);
    if (!paused) startTimer();
  });

  const requestedTopic = new URLSearchParams(window.location.search).get('topic');
  if (inquiryField && requestedTopic) {
    const normalizeTopic = window.PublicSandInquiry.normalizeTopic;
    const option = [...inquiryField.options].find((item) => normalizeTopic(item.value) === normalizeTopic(requestedTopic));
    if (option) inquiryField.value = option.value;
  }

  const contactForm = document.querySelector('#ContactForm');
  const orderNumberField = contactForm?.querySelector('[name="contact[Order number]"]');
  if (contactForm && inquiryField && orderNumberField) {
    const retryKey = `public-sand-contact-retry:${window.location.pathname}`;
    const formHasErrors = Boolean(contactForm.querySelector('[data-contact-form-errors]'));

    if (formHasErrors) {
      try {
        const retryValues = JSON.parse(window.sessionStorage.getItem(retryKey) || 'null');
        if (retryValues) {
          const normalizeTopic = window.PublicSandInquiry.normalizeTopic;
          const option = [...inquiryField.options].find((item) => normalizeTopic(item.value) === normalizeTopic(retryValues.topic));
          if (option) inquiryField.value = option.value;
          orderNumberField.value = typeof retryValues.orderNumber === 'string' ? retryValues.orderNumber : '';
        }
      } catch {
        // Keep the form usable if this browser blocks session storage or its contents are invalid.
      }
    }

    try {
      window.sessionStorage.removeItem(retryKey);
      if (!formHasErrors) {
        contactForm.addEventListener('submit', () => {
          try {
            window.sessionStorage.setItem(retryKey, JSON.stringify({
              topic: inquiryField.value,
              orderNumber: orderNumberField.value,
            }));
          } catch {
            // Submission remains functional if session storage is unavailable.
          }
        });
      }
    } catch {
      // Submission remains functional if session storage is unavailable.
    }
  }
})();
